import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { formatApiError } from "../lib/api";

const BG = "https://images.unsplash.com/photo-1644896916261-655117008649";

export default function Login() {
  const nav = useNavigate();
  const loc = useLocation();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await login(email, password);
      nav(loc.state?.from || "/marketplace");
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail) || e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img src={BG} alt="forest" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-tr from-ink/40 via-transparent to-transparent" />
        <div className="absolute bottom-10 left-10 text-white">
          <div className="font-serif text-4xl leading-tight max-w-md">"Markets that finance the planet."</div>
          <div className="font-mono text-xs mt-3 tracking-widest">GREENBELT EXCHANGE</div>
        </div>
      </div>

      <div className="flex items-center justify-center p-8 lg:p-16 bg-bg">
        <div className="w-full max-w-sm">
          <Link to="/" className="flex items-center gap-3">
            <img
              src="https://customer-assets.emergentagent.com/job_credit-marketplace-11/artifacts/xeso8axu_image.png"
              alt="GreenBelt"
              className="h-10 w-10 object-cover rounded-sm"
            />
            <span className="font-serif text-2xl">GreenBelt</span>
          </Link>
          <h1 className="font-serif text-4xl mt-10 tracking-tight">Sign in</h1>
          <p className="text-sm text-ink2 mt-2">Welcome back to your carbon portfolio.</p>

          <form onSubmit={submit} className="mt-10 space-y-4">
            <div>
              <label className="label-tag block mb-2">Email</label>
              <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-field" />
            </div>
            <div>
              <label className="label-tag block mb-2">Password</label>
              <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input-field" />
            </div>
            {err && <div className="text-sm text-danger font-sans" data-testid="login-error">{err}</div>}
            <button data-testid="login-submit" type="submit" disabled={busy} className="btn-primary w-full disabled:opacity-50">
              {busy ? "Signing in…" : "Sign in →"}
            </button>
          </form>
          <p className="mt-8 text-sm text-ink2">No account? <Link to="/register" className="text-ink underline">Open one</Link>.</p>
        </div>
      </div>
    </div>
  );
}
